import { apiHeaders } from '../../utils/utils'
import axiosWrapper, { axiosRMSWrapper } from '../helpers/api'
import { ERequestUrl, EMethods, RMSRequestUrl } from '../helpers/requests'
import { LOCAL_STORAGE_KEYS } from '../../utils/constants'

const authHeaders = () => {
  const token = localStorage?.getItem(LOCAL_STORAGE_KEYS.TOKEN)
  return token
    ? apiHeaders(localStorage.getItem(LOCAL_STORAGE_KEYS.CONNEXION_TYPE))
    : {}
}

export const postProductToReturn = (data) => {
  return axiosWrapper({
    method: EMethods.post,
    origin: process.env.API_DOMAIN,
    url: ERequestUrl.return,
    data: data,
    headers: authHeaders(),
  })
}

export const getOrderInvoice = (orderToken: number) =>
  axiosWrapper({
    method: EMethods.get,
    url: ERequestUrl.invoice,
    uid: orderToken + '/invoice/download',
  })

export const getProductReturningReasons = (locale: string) =>
  axiosRMSWrapper({
    method: EMethods.get,
    url: RMSRequestUrl.productReturningReasons,
    uid: locale,
  })

export const getOrderReturnLabel = (omsOrderId: string) =>
  axiosRMSWrapper({
    method: EMethods.get,
    url: RMSRequestUrl.rightOfWithdrawal,
    uid: `${omsOrderId}/return-label`,
    headers: authHeaders(),
  })
